module.exports = __webpack_public_path__ + "img/15b08f0.jpg";